/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function() {
        // JavaScript to be fired on all pages
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = funcname === undefined ? "init" : funcname;
      fire = func !== "";
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === "function";

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire("common");

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, "_").split(/\s+/), function(
        i,
        classnm
      ) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, "finalize");
      });

      // Fire common finalize JS
      UTIL.fire("common", "finalize");
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.


// IDENTIFY AND ISOLATE EXTERNAL LINKS
jQuery(document).ready(function(){
  jQuery("a").filter(function(){ return this.hostname && this.hostname!==location.hostname; })
    .attr("target","_blank")
    .attr("rel","noopener");
});


// IS TOP IN VIEWPORT?
function topInViewport(element) {
  return (
    jQuery(element).offset().top >= jQuery(window).scrollTop() &&
    jQuery(element).offset().top <=
      jQuery(window).scrollTop() + jQuery(window).height()
  );
}
/*
jQuery(window).on("load resize scroll",function(e){
  if ( topInViewport($this) && $this.text()==='0' ) {
    // SOME CODE HERE
  }
});
*/

// IS ELEMENT IN VIEWPORT?
/* jshint ignore:start */
/**
 * jQuery-viewport-checker - v1.8.8 - 2017-09-25
 * https://github.com/dirkgroenen/jQuery-viewport-checker
 * Copyright (c) 2017 Dirk Groenen
 */
!(function(a) {
  a.fn.viewportChecker = function(b) {
    var c = {
      classToAdd: "visible",
      classToRemove: "invisible",
      classToAddForFullView: "full-visible",
      removeClassAfterAnimation: !1,
      offset: 100,
      repeat: !1,
      invertBottomOffset: !0,
      callbackFunction: function(a, b) {},
      scrollHorizontal: !1,
      scrollBox: window
    };
    a.extend(c, b);
    var d = this,
      e = { height: a(c.scrollBox).height(), width: a(c.scrollBox).width() };
    return (
      (this.checkElements = function() {
        var b, f;
        c.scrollHorizontal
          ? ((b = Math.max(
              a("html").scrollLeft(),
              a("body").scrollLeft(),
              a(window).scrollLeft()
            )),
            (f = b + e.width))
          : ((b = Math.max(
              a("html").scrollTop(),
              a("body").scrollTop(),
              a(window).scrollTop()
            )),
            (f = b + e.height)),
          d.each(function() {
            var d = a(this),
              g = {},
              h = {};
            if (
              (d.data("vp-add-class") &&
                (h.classToAdd = d.data("vp-add-class")),
              d.data("vp-remove-class") &&
                (h.classToRemove = d.data("vp-remove-class")),
              d.data("vp-add-class-full-view") &&
                (h.classToAddForFullView = d.data("vp-add-class-full-view")),
              d.data("vp-keep-add-class") &&
                (h.removeClassAfterAnimation = d.data(
                  "vp-remove-after-animation"
                )),
              d.data("vp-offset") && (h.offset = d.data("vp-offset")),
              d.data("vp-repeat") && (h.repeat = d.data("vp-repeat")),
              d.data("vp-scrollHorizontal") &&
                (h.scrollHorizontal = d.data("vp-scrollHorizontal")),
              d.data("vp-invertBottomOffset") &&
                (h.scrollHorizontal = d.data("vp-invertBottomOffset")),
              a.extend(g, c),
              a.extend(g, h),
              !d.data("vp-animated") || g.repeat)
            ) {
              String(g.offset).indexOf("%") > 0 &&
                (g.offset = parseInt(g.offset) / 100 * e.height);
              var i = g.scrollHorizontal ? d.offset().left : d.offset().top,
                j = g.scrollHorizontal ? i + d.width() : i + d.height(),
                k = Math.round(i) + g.offset,
                l = g.scrollHorizontal ? k + d.width() : k + d.height();
              g.invertBottomOffset && (l -= 2 * g.offset),
                k < f && l > b
                  ? (d.removeClass(g.classToRemove),
                    d.addClass(g.classToAdd),
                    g.callbackFunction(d, "add"),
                    j <= f && i >= b
                      ? d.addClass(g.classToAddForFullView)
                      : d.removeClass(g.classToAddForFullView),
                    d.data("vp-animated", !0),
                    g.removeClassAfterAnimation &&
                      d.one(
                        "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                        function() {
                          d.removeClass(g.classToAdd);
                        }
                      ))
                  : d.hasClass(g.classToAdd) &&
                    g.repeat &&
                    (d.removeClass(
                      g.classToAdd + " " + g.classToAddForFullView
                    ),
                    g.callbackFunction(d, "remove"),
                    d.data("vp-animated", !1));
            }
          });
      }),
      ("ontouchstart" in window || "onmsgesturechange" in window) &&
        a(document).bind(
          "touchmove MSPointerMove pointermove",
          this.checkElements
        ),
      a(c.scrollBox).bind("load scroll", this.checkElements),
      a(window).resize(function(b) {
        (e = {
          height: a(c.scrollBox).height(),
          width: a(c.scrollBox).width()
        }),
          d.checkElements();
      }),
      this.checkElements(),
      this
    );
  };
})(jQuery);
/* jshint ignore:end */

// TOPNAV AND FLYOUTS
// Top Navigation Open & Close
jQuery(".toggle_topnav button").click(function() {
  jQuery("#topnav").addClass("show");
  return false;
});
jQuery("#topnav .close").click(function() {
  jQuery("#topnav").removeClass("show");
  return false;
});


// VISIBLE CAROUSEL CAPTURE KEYBOARD
jQuery(document).bind('keyup', function(e) {
  if(e.which === 39){
    jQuery('.show .carousel').carousel('next');
  }
  else if(e.which === 37){
    jQuery('.show .carousel').carousel('prev');
  }
});



// BACK LINK: determine whether to go back or to a base page
function backlink( base ) {
  if(base === undefined) {
    base = window.location.protocol + '//' + window.location.host + '/#';
  }
  console.log(document.referrer);
  // if the previous link is in this domain, go to history -1
  if ( document.referrer.indexOf(window.location.host) > -1 ) {
    console.log('Back to '+ document.referrer);
    history.go(-1); e.preventDefault(); return false;
  }
  // else go to the base page
  else {
    console.log(base);
    window.location.href = base; e.preventDefault(); return false;
  }
}


// OVERLAY LOGIC

// OVERLAY FIXATION
function overlayscrollFix() {
  jQuery(".overlay.show").each(function() {
    var overlays = jQuery(this)
      .parents(".overlays")
      .offset();
    var scrollpoint = jQuery(window).scrollTop();
    if (overlays.top < scrollpoint) {
      jQuery(this)
        .addClass("scroll_fixed")
        .removeClass("scroll_absolute");
    } else {
      jQuery(this)
        .removeClass("scroll_fixed")
        .addClass("scroll_absolute");
    }
  });
}
jQuery(window).scroll(function() {
  overlayscrollFix();
});

//////////////////////////////////////////////////////
// Overlay Open ////////////////////////////////////
//////////////////////////////////////////////////////
jQuery(
  ".overlays .directory-grid a.click, .overlays a.overlaylink, .overlays li.overlaylink a, .page-header.video.overlays .play"
).on("click", function(e) {
  e.preventDefault();
  /* get overlay details */
  var id = jQuery(this).attr("data-id");
  var container = jQuery(this).parents(".overlays");
  /* slide to top if it's a video overlay */
  if (jQuery(this).hasClass("play")) {
    var offset = jQuery(this)
      .parents(".overlays")
      .offset();
    jQuery("html,body").animate({ scrollTop: offset.top }, 500, "swing");
  }
  /* hide other overlays */
  jQuery(".overlays")
    .not(container)
    .each(function() {
      jQuery(this)
        .find(".overlay.show")
        .removeClass("show");
    });
  jQuery(".overlays").
    each(function() {
      jQuery(this)
        .find(".directory-items.show")
        .removeClass("show");
    });
  /* show the overlay, activate the appropriate slide */
  jQuery(container)
    .children(".overlay")
    .addClass("show")
    .find(".detail-" + id)
    .addClass("active")
    .siblings()
    .removeClass("active");
  overlayscrollFix();
  return false;
});
// Directory Grid becomes .show when detail-carousel is closed
jQuery('.detail-view .close').on('click',function() {
  jQuery(this).parents('.overlays').find('.directory-items').addClass('show');
});


// REDUNDANCY FOR PROGRAMS AND AGENDAS onHOVER
jQuery(".directory-grid a.hover").on("hover", function(e) {
  if (jQuery(this).hasClass("play")) {
    var offset = jQuery(this)
      .parents(".overlays")
      .offset();
    jQuery("html,body").animate({ scrollTop: offset.top }, 500, "swing");
  }
  var id = jQuery(this).attr("data-id");
  var container = jQuery(this).parents(".overlays");
  /* un-show other overlays */
  jQuery(".overlays")
    .not(container)
    .each(function() {
      jQuery(this)
        .find(".overlay.show")
        .removeClass("show");
    });
  jQuery(container)
    .children(".overlay")
    .addClass("show")
    .find(".detail-" + id)
    .addClass("active")
    .siblings()
    .removeClass("active");
  overlayscrollFix();
  e.preventDefault();
  return false;
});

// AGENDA SCHEDULE PRESENTERS -> MENTORS SECTION
jQuery(".directory-grid a.click_slide").on("click, click", function(e) {
  var id = jQuery(this).attr("data-id");
  var slide = jQuery("body")
    .find(".carousel-item.detail-" + id)
    .first();
  var container = jQuery(slide).parents(".overlays");
  var slidepos;
  if (jQuery(container).prev("h2")) {
    slidepos = jQuery(container)
      .prev("h2")
      .offset();
  } else {
    slidepos = jQuery(container).offset();
  }
  /* un-show other overlays */ jQuery(".overlays")
    .not(container)
    .each(function() {
      jQuery(this)
        .find(".overlay.show")
        .removeClass("show");
    });
  jQuery(slide)
    .addClass("active")
    .siblings()
    .removeClass("active")
    .parents(".overlay")
    .addClass("show");
  jQuery("html, body").animate({ scrollTop: slidepos.top }, 800);
  overlayscrollFix();
  e.preventDefault();
  return false;
});

// PROGRAM/COUNTRY LINKED AGENDA CTAS
jQuery(".cta.overlays .agenda.button").click(function(e) {
  jQuery(this)
    .parents(".overlays")
    .children(".overlay")
    .addClass("show");
  overlayscrollFix();
  e.preventDefault();
  return false;
});

// Overlay Close
jQuery(".hexbutton.close").on("click", function() {
  jQuery(this)
    .parents(".overlay")
    .removeClass("show");
  return false;
});
// CLOSE OVERLAYS ON ESC
jQuery(document).keyup(function(e) {
  if (e.keyCode === 27) {
    jQuery(".close").click();
  }
});

// HEXAGON IMAGES
jQuery(document).ready(function() {
  jQuery(".hexagon.image").each(function() {
    var image = jQuery(this)
      .find("img")
      .prop("src");
    jQuery(this)
      .find("img")
      .hide();
    jQuery(this)
      .append(
        '<div class="hexagon-i1"><div class="hexagon-i2"><div class="hexagon-i3"></div></div><div>'
      )
      .find(".hexagon-i3")
      .css("background-image", "url(" + image + ")");
  });
});

// CAROUSEL INIT IN VIEW
jQuery(document).ready(function() {
  //jQuery('.carousel').carousel('pause'); // load page with carousel paused
  jQuery(".carousel")
    .not(".detail")
    .each(function() {
      var carousel = jQuery(this).attr("id");
      jQuery(this).viewportChecker({
        offset: 200, // wait for the first 200 pixel of the element to enter in the viewport
        callbackFunction: function(elem) {
          setTimeout(function() {
            jQuery("#" + carousel).carousel(); // remove pause
          }, 500);
        }
      });
    });
});

// Add Touch Capacity to Carousels
(function($) {
  var touchStartX = null;
  $(".carousel").each(function() {
    var $carousel = $(this);
    $(this)
      .on("touchstart", function(event) {
        var e = event.originalEvent;
        if (e.touches.length === 1) {
          var touch = e.touches[0];
          touchStartX = touch.pageX;
        }
      })
      .on("touchmove", function(event) {
        var e = event.originalEvent;
        if (touchStartX != null) {
          var touchCurrentX = e.changedTouches[0].pageX;
          if (touchCurrentX - touchStartX > 60) {
            touchStartX = null;
            $carousel.carousel("prev");
          } else if (touchStartX - touchCurrentX > 60) {
            touchStartX = null;
            $carousel.carousel("next");
          }
        }
      })
      .on("touchend", function() {
        touchStartX = null;
      });
  });
})(jQuery);

// MAP CORRESPONDENCE
jQuery(".international-map .mapicon").hover(
  function() {
    var country = jQuery(this).attr("data-country");
    jQuery(".maplink." + country).addClass("hover");
  },
  function() {
    var country = jQuery(this).attr("data-country");
    jQuery(".maplink." + country).removeClass("hover");
  }
);
jQuery(".maplink").hover(
  function() {
    var country = jQuery(this).attr("data-country");
    jQuery(".mapicon." + country).addClass("hover");
  },
  function() {
    var country = jQuery(this).attr("data-country");
    jQuery(".mapicon." + country).removeClass("hover");
  }
);

// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = jQuery("header").outerHeight();

jQuery(window).on("scroll", function(event) {
  didScroll = true;
});

function hasScrolled() {
  var st = jQuery(this).scrollTop();
  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta) {
    return;
  }

  // If they scrolled down and are past the navbar, add class .nav-up.
  // This is necessary so you never see what is "behind" the navbar.
  if (st > lastScrollTop && st > navbarHeight) {
    // Scroll Down
    jQuery("header,body")
      .removeClass("nav-down")
      .addClass("nav-up");
  } else {
    // Scroll Up
    if (st + jQuery(window).height() < jQuery(document).height()) {
      jQuery("header,body")
        .removeClass("nav-up")
        .addClass("nav-down");
    }
  }
  lastScrollTop = st;
}

setInterval(function() {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

// Fix Vertical Title height
jQuery(".vertical-title").each(function() {
  var $this = jQuery(this),
    child = $this.children(":first");
  $this.css("minHeight", function() {
    return child[0].getBoundingClientRect().height;
  });
});

function carouselNormalization() {
  jQuery(".carousel").each(function() {
    var items = jQuery(this).find(".carousel-item"); //grab all slides

    //  if (items.length) {
    function normalizeHeights() {
      var heights = [], //create empty array to store height values
        tallest = 0; //create variable to make note of the tallest slide
      items.each(function() {
        jQuery(this).css("min-height", "0");
        //add heights to array
        heights.push(jQuery(this).height());
      });
      tallest = Math.max.apply(null, heights) + 20; //cache largest value
      items.each(function() {
        jQuery(this).css("min-height", tallest + "px");
      });
    }
    if (items.length) {
      normalizeHeights();
    }

    jQuery(window).on("resize orientationchange", function() {
      tallest = 0;
      var heights = 0; //reset vars
      items.each(function() {
        jQuery(this).css("min-height", "0"); //reset min-height
      });
      if (items.length) {
        normalizeHeights();
      } //run it again
    });
    //  }
  });
}
jQuery(document).ready(carouselNormalization());

// AGENDA ACCESS
function agendaAccess(cururl) {
  var code = prompt("Please enter your access code", "");
  if (code == null || code === "") {
    return false;
  } else {
    cururl += "?code=" + code;
    window.location.assign(cururl);
  }
}

// SCHEDULE TABULAR LOGIC
// day
jQuery(".schedule .day > a").on("click", function() {
  // set this day to active
  jQuery(this)
    .parents("li")
    .addClass("active")
    .siblings(".day")
    .removeClass("active");
  // set first timeslot to active
  jQuery(this)
    .parents("li")
    .find(".timeslots li")
    .first()
    .addClass("active")
    .siblings()
    .removeClass("active");
  var thistime = jQuery(this)
    .parents("li")
    .find(".timeslot")
    .first()
    .attr("data-timeslot");
  // show the timeslot content
  jQuery(".schedule .timeslot." + thistime)
    .addClass("active")
    .siblings(".timeslot")
    .removeClass("active");
});
// time
jQuery(".schedule .timeslot a").on("click", function() {
  // set this timeslot to active
  jQuery(this)
    .parent("li")
    .addClass("active")
    .siblings("li")
    .removeClass("active");
  var thistime = jQuery(this)
    .parents("li")
    .attr("data-timeslot");
  // show the timeslot content
  jQuery(".schedule .timeslot." + thistime)
    .addClass("active")
    .siblings(".timeslot")
    .removeClass("active");
});
// click scroll fix
jQuery(".schedule .tabs a").click(function(e) {
  e.preventDefault();
  return false;
});




// Number Counter
jQuery(".counter").each(function() {
  var $this = jQuery(this),
    countTo = $this.text();
  $this.text("0");
  jQuery(window).on("load resize scroll", function(e) {
    if (topInViewport($this) && $this.text() === "0") {
      jQuery({ countNum: $this.text() }).animate(
        {
          countNum: countTo
        },
        {
          duration: 2000,
          easing: "linear",
          step: function() {
            $this.text(Math.floor(this.countNum));
          },
          complete: function() {
            $this.text(this.countNum);
            //alert('finished');
          }
        }
      );
    }
  });
});

// PAUSE ALL VIDEOS WITH ONE ACTION
function stopVideo(container) {
  jQuery(container)
    .parents(".overlay")
    .find(".active iframe")
    .each(function() {
      var iframeSrc = jQuery(this).attr("src");
      jQuery(this).attr("src", iframeSrc);
      //        jQuery(this).contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });
  jQuery(container)
    .parents(".overlay")
    .find("video")
    .each(function() {
      jQuery(this).pause();
    });
}
// pause all carousel videos on slide or hide
jQuery(".overlay .carousel").on("slide.bs.carousel", function() {
  stopVideo(this);
});
jQuery(".hexbutton.close").on("click", function() {
  stopVideo(this);
});

// AutoResize Text
// https://coderwall.com/p/_8jxgw/autoresize-text-to-fit-into-a-div-width-height
function fittext() {
  var elements = jQuery(".fittext");
  if (elements.length < 0) {
    return;
  }
  elements.each(function(i, element) {
    while (
      element.scrollWidth > element.offsetWidth ||
      element.scrollHeight > element.offsetHeight
    ) {
      var newFontSize =
        parseFloat(
          jQuery(element)
            .css("font-size")
            .slice(0, -2)
        ) *
          0.95 +
        "px";
      jQuery(element).css("font-size", newFontSize);
    }
  });
}
jQuery(document).ready(fittext());
jQuery(window).on("resize orientationchange", function() {
  fittext();
});

// Directory Search
jQuery(".directory-search").on("submit", function(e) {
  // Sorting
  var searchTerm = jQuery(this)
    .find(".directory-query")
    .val()
    .toLowerCase();
  jQuery(".directory-items .item").each(function() {
    if (
      jQuery(this).filter("[data-search-term *= " + searchTerm + "]").length >
        0 ||
      searchTerm.length < 1
    ) {
      jQuery(this).show();
    } else {
      jQuery(this).hide();
    }
  });
  // Scroll to Lazy Load
  var currentscroll = jQuery(window).scrollTop();
  jQuery(window)
    .scrollTop(currentscroll + 1)
    .scrollTop(currentscroll);
  // Don't leave!
  e.preventDefault();
  return false;
});


// Copy text to clipboard
jQuery('.copy-link').click( function(e) {
  e.preventDefault();
  var copyFrom = jQuery(this).attr('data-ref');
  var copyInput = document.getElementById(copyFrom);
  copyInput.select();
  document.execCommand('copy');
  alert('Copied this link: ' + copyInput.value);
});




// MAILCHIMP EMAIL FORM FUNCTIONALITY
/*
  // alternatively - jQuery('form.mailchimp').on('submit', function(e){
jQuery('#mce-success-response').bind('DOMSubtreeModified',function(event) {
  var success_content = jQuery(this).text();
  if(success_content === "Thank you for subscribing!") {
    jQuery('#mce_inline_error').hide();
    setTimeout( function(){
      jQuery('#mce-success-response').parents('.overlay').removeClass('show');
      jQuery('#mce-success-response').hide();
    }  , 2000 );
  }
});
*/
